import axios from "axios";
import { getAPIEndpointUrl} from "./ServerRequestModifier";

export default axios.create({
  baseURL: getAPIEndpointUrl() + "/api/admin",
  headers: {
    "Content-type": "application/json"
  },
});
